export default {
  create: 'Crear',
}
